/**
 * iOS: Network Extension + Family Controls require Xcode on macOS, Apple entitlements,
 * and a development team. This module calls NativeModules.IosScreenTimeControl when linked.
 * Until native code is added, methods reject or return false — no data leaves the device.
 */

import { NativeModules, Platform } from "react-native";

const IOS = Platform.OS === "ios" ? NativeModules.IosScreenTimeControl : null;

export function iosScreenTimeSupported() {
  return !!IOS;
}

export async function startDnsFiltering() {
  if (!IOS?.startProtection) {
    throw new Error(
      "iOS DNS filtering is not linked yet. On macOS: add Network Extension target, entitlements, and IosScreenTimeControl native module (see native-ios/IOS_BUILD_NOTES.txt)."
    );
  }
  return IOS.startProtection();
}

export async function stopDnsFiltering() {
  if (!IOS?.stopProtection) return false;
  return IOS.stopProtection();
}

export async function isProtectionActive() {
  if (!IOS?.isProtectionActive) return false;
  try {
    return await IOS.isProtectionActive();
  } catch {
    return false;
  }
}

export function syncRulesToExtension(jsonString) {
  IOS?.updateRulesJson?.(jsonString);
}

/** Family Controls / Screen Time API — requires com.apple.developer.family-controls entitlement. */
export async function requestFamilyControlsAuthorization() {
  if (!IOS?.requestAuthorization) {
    throw new Error("Family Controls not linked. Requires entitlement from Apple.");
  }
  return IOS.requestAuthorization();
}

export async function presentAppPickerForLimits() {
  if (!IOS?.presentAppPicker) {
    throw new Error("Family Controls UI not linked.");
  }
  return IOS.presentAppPicker();
}
